// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"170":"css/app","213":"css/floats","829":"css/app-rtl"}[chunkId] + ".css";
};